import React from 'react';
import styled from 'react-emotion';
import MaxWidth from '../Layout/MaxWidth';
import SubCategories from './SubCategories';

const Wrapper = styled('div')`
  margin-bottom: 1rem;
`;

const CategoryName = styled('h1')`
  font-weight: 600;
  line-height: normal;
  font-size: 22px;
  margin-bottom: 10px;
`;

const CategoryContent = styled('div')`
  p {
    line-height: 1.6;
  }
`;

const CategoryHeader = ({ category }) => {
  const { name, mainHeader } = category;

  return (
    <Wrapper>
      <MaxWidth>
        <CategoryName data-testid="page-header">
          {mainHeader ? mainHeader : name}
        </CategoryName>
        <CategoryContent
          data-testid="category-description"
          dangerouslySetInnerHTML={{
            __html: category.content
          }}
        />
        <SubCategories key={category.id} category={category} />
      </MaxWidth>
    </Wrapper>
  );
};

export default CategoryHeader;
